export const CrossIcon = ({ classes }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 16 15"
      className={classes}
    >
      <g clipPath="url(#clip0_0_6282)">
        <path
          fill="currentColor"
          d="M1.98638 14.906C1.61862 14.9274 1.25695 14.8052 0.97762 14.565C0.426731 14.0109 0.426731 13.1159 0.97762 12.5617L13.0403 0.498994C13.6133 -0.0371562 14.5123 -0.00735193 15.0485 0.565621C15.5333 1.08376 15.5616 1.88015 15.1147 2.43132L2.98092 14.565C2.70519 14.8017 2.34932 14.9237 1.98638 14.906Z"
        />
        <path
          fill="currentColor"
          d="M14.0347 14.9061C13.662 14.9045 13.3047 14.7565 13.0401 14.4941L0.977383 2.4313C0.467013 1.83531 0.536401 0.938371 1.13239 0.427954C1.66433 -0.0275797 2.44884 -0.0275797 2.98073 0.427954L15.1145 12.4907C15.6873 13.027 15.7169 13.9261 15.1806 14.4989C15.1593 14.5217 15.1372 14.5437 15.1145 14.5651C14.8174 14.8234 14.4263 14.9469 14.0347 14.9061Z"
        />
      </g>

      <defs>
        <clipPath id="clip0_0_6282">
          <rect width="15" height="15" transform="translate(0.564453)" />
        </clipPath>
      </defs>
    </svg>
  );
};


export const ThreeDotsMenuIcon = () => {
  return (
    <span className="icn ">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="13"
        viewBox="0 0 28 13"
        fill="none"
      >
        <rect width="28" height="13" rx="6.5" fill="" />
        <path
          d="M23.2678 4.73223C22.2915 3.75592 20.7085 3.75592 19.7322 4.73223C18.7559 5.70854 18.7559 7.29146 19.7322 8.26777C20.7085 9.24408 22.2915 9.24408 23.2678 8.26777C24.2441 7.2915 24.2441 5.70858 23.2678 4.73223Z"
          fill="#8f8f8f"
        />
        <path
          d="M16.2678 4.73223C15.2915 3.75592 13.7085 3.75592 12.7322 4.73223C11.7559 5.70854 11.7559 7.29146 12.7322 8.26777C13.7085 9.24408 15.2915 9.24408 16.2678 8.26777C17.2441 7.2915 17.2441 5.70858 16.2678 4.73223"
          fill="#8f8f8f"
        />
        <path
          d="M9.26777 4.73223C8.29146 3.75592 6.70854 3.75592 5.73223 4.73223C4.75592 5.70854 4.75592 7.29146 5.73223 8.26777C6.70854 9.24408 8.29146 9.24408 9.26777 8.26777C10.2441 7.2915 10.2441 5.70858 9.26777 4.73223"
          fill="#8f8f8f"
        />
      </svg>
    </span>
  )
}


export const RightArrowIcon = () => {
  return (
    <svg width="9" height="12" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.373657 9.33215L4.37366 4.83215L0.373657 0.332153" stroke="black" />
    </svg>
  )
}

export const RightArrowIconNew = () => {
    return (
        <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.68197 2.74568L8.85675 0H10.2193L14 3.79259V4.20741L10.2193 8H8.85675L9.68197 5.25432H0V2.74568H9.68197Z" fill="white" />
        </svg>
    )
}


export const DownArrowIcon = () => {
  return (
    <svg
      width="12"
      height="9"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: "rotate(90deg)" }}
    >
      <path
        d="M0.373657 9.33215L4.37366 4.83215L0.373657 0.332153"
        stroke="black"
        strokeWidth="1"
      />
    </svg>
  );
};

export const LeftArrowIcon = () => {
  return (
    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.31803 2.74568L5.14325 0H3.78067L0 3.79259V4.20741L3.78067 8H5.14325L4.31803 5.25432H14V2.74568H4.31803Z" fill="#93278F" />
    </svg>
  )
}
